import * as Html from "../../util/Html.ts";
export {init}
Html.registerWidget('widget/form/submitonanychange',{init:init})

function init(node){
  node.find(':input').on('change',function(){
    node.trigger('submit')
  })
}  